export enum CosmosChain {
  Juno = "juno",
  Kujira = "kujira",
}
